import { notifications } from "@mantine/notifications";

const errorMessage = (error: unknown): string =>
  error instanceof Error
    ? error.message
    : "Something went wrong. Please try again.";

export const notifyError = (title: string, error: unknown) =>
  notifications.show({ color: "red", title, message: errorMessage(error) });

export const notifyWarning = (title: string, error: unknown) =>
  notifications.show({ color: "orange", title, message: errorMessage(error) });

export const notifySuccess = (title: string, message: string) =>
  notifications.show({ color: "green", title, message });
